import { lastDayOfMonth, format } from "date-fns";

const accessToken = process.env.REACT_APP_TOKEN;

async function harvestFetch(url) {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(
      `Harvest API error ${response.status}: ${response.statusText}`
    );
  }

  return response.json();
}

export async function fetchAccounts() {
  const result = await harvestFetch(
    `https://id.getharvest.com/api/v2/accounts?access_token=${accessToken}`
  );

  return result.accounts;
}

export async function fetchUsers(accountId) {
  const result = await harvestFetch(
    `https://api.harvestapp.com/v2/users?access_token=${accessToken}&account_id=${accountId}&is_active=true`
  );

  return result.users;
}

export async function fetchProjectsWithTimeEntries(accountId, period) {
  const firstDate = new Date(period.year, period.month, 1);

  const from = format(firstDate, "yyyy-MM-dd");
  const to = format(lastDayOfMonth(firstDate), "yyyy-MM-dd");

  const result = await harvestFetch(
    `https://api.harvestapp.com/v2/time_entries?access_token=${accessToken}&account_id=${accountId}&from=${from}&to=${to}`
  );

  return result;
}

export async function fetchProjectsWithSubSupliers(accountId) {
  const result = await harvestFetch(
    `https://api.harvestapp.com/v2/projects?access_token=${accessToken}&account_id=${accountId}&is_active=true`
  );

  return result.projects.filter((project) => {
    if (!project.code) {
      return false;
    }

    return (
      project.code.replace(/\s/g, "").toUpperCase().slice(-2) === "-S"
    );
  });
}